import {
  PRE_CALL_SMS_DEFAULT_MINUTES,
  PRE_CALL_SMS_FALLBACK_AGENT_NAME,
  PRE_CALL_SMS_FALLBACK_CUSTOMER_FIRST_NAME,
} from '~/consts/preCallSms';

export function buildCustomerSmsPhoneNumber(
  phonePrefix: string | null | undefined,
  phone: string | null | undefined,
): string | null {
  const local = phone == null ? '' : String(phone).replace(/\s+/g, '');
  const prefix = phonePrefix == null ? '' : String(phonePrefix).replace(/[^\d]/g, '');

  if (!local || !prefix) {
    return null;
  }

  return `+${prefix}${local}`;
}

export function resolvePreCallSmsCustomerFirstName(givenName: string | null | undefined): string {
  const trimmed = givenName?.trim();
  return trimmed || PRE_CALL_SMS_FALLBACK_CUSTOMER_FIRST_NAME;
}

export function resolvePreCallSmsAgentName(
  agent: { givenName?: string | null; fullName?: string | null } | null | undefined,
): string {
  const givenName = agent?.givenName?.trim();
  if (givenName) {
    return givenName;
  }

  const fullName = agent?.fullName?.trim();
  if (fullName) {
    return fullName;
  }

  return PRE_CALL_SMS_FALLBACK_AGENT_NAME;
}

export function buildPreCallSmsMessage({
  customerFirstName,
  agentName,
  brandName,
  minutes = PRE_CALL_SMS_DEFAULT_MINUTES,
}: {
  customerFirstName: string;
  agentName: string;
  brandName: string;
  minutes?: number;
}): string {
  return [
    `Hi ${customerFirstName}, ${agentName} from ${brandName} will call you in around ${minutes} minutes about your enquiry.`,
    `Please don't reply to this SMS as it is unmonitored.`,
  ].join('\n');
}
